<template>
  <div>
    <YsDataTable
      v-model="refresh"
      :list="searchList"
      :button-list="buttonList"
      :columns="columns"
      :fetch-method="fetchMethod"
      list-field="reportDetailList"
      :transform-params="handleFormatSearch"
      page-size-alias="page_size"
      :page-sizes="[100, 500, 1000]"
      :page-size="100"
      use-data-field
      @on-fetch-success="handleFetchSuccess"
      @on-reset="handleReset"
    >
      <template slot="supply_id">
        <el-input
          v-model="searchForm.supply_id"
          placeholder="商家ID"
          @input="handleChange"
        ></el-input>
      </template>
      <template slot="supply_name">
        <el-select
          v-model="searchForm.supply_name"
          filterable
          remote
          reserve-keyword
          clearable
          placeholder="商家名称"
          :remote-method="remoteMethod"
          @change="handleSelectChange"
        >
          <el-option
            v-for="item in supplyNameOptions"
            :key="item.supply_id"
            :label="item.supply_name"
            :value="item.supply_id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="city">
        <el-select
          v-model="searchForm.city"
          filterable
          reserve-keyword
          clearable
          placeholder="城市"
          multiple
        >
          <el-option
            v-for="item in cityOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="market">
        <el-select
          v-model="searchForm.market_id"
          filterable
          reserve-keyword
          clearable
          placeholder="市场"
          multiple
        >
          <el-option
            v-for="item in marketOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="purchase_group">
        <el-select
          v-model="searchForm.pgid"
          filterable
          reserve-keyword
          clearable
          placeholder="代采组"
          multiple
        >
          <el-option
            v-for="item in purchaseGroupOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="dg_member">
        <el-select
          v-model="searchForm.dg_member_id"
          filterable
          reserve-keyword
          clearable
          placeholder="次品员"
          multiple
        >
          <el-option
            v-for="item in defectiveProductSpecialistOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="reportMsg">
        <span style="color: red">最多导出2w数据！</span>
      </template>
      <template slot="table-content">
        <el-card style="margin-bottom: 16px">
          <div slot="header">
            <div class="title">汇总（全部）</div>
          </div>
          <el-table
            :data="totalDetail"
            tooltip-effect="dark"
            style="width: 100%"
            border
          >
            <el-table-column
              align="center"
              prop="total_return"
              label="总退换货"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="owe_pending"
              label="转欠货待处理"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="owe_processed"
              label="转欠货已换回"
            >
            </el-table-column>
            <el-table-column align="center" prop="refund" label="退款">
            </el-table-column>
            <el-table-column
              align="center"
              prop="stagnant_debts"
              label="转呆账"
            >
            </el-table-column>
            <el-table-column align="center" prop="bad_debt" label="转坏账">
            </el-table-column>
            <el-table-column align="center" prop="deduct" label="转抵扣">
            </el-table-column>
          </el-table>
        </el-card>
      </template>
      <template slot="action" slot-scope="{ row }">
        <el-button type="primary" size="mini" @click="hanleLookDetail(row)">
          查看详情
        </el-button>
      </template>
    </YsDataTable>
    <!-- 详情 -->
    <el-dialog
      title="报表详情"
      :visible.sync="isShowDetailDialog"
      width="80%"
      top="8vh"
    >
      <reject-statement-detail
        v-if="isShowDetailDialog"
        :detail-data="detailData"
      ></reject-statement-detail>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import RejectStatementDetail from "./RejectStatementDetail.vue";
// import {
//   getRejectDateLogReport,
//   getSupplyIdByName,
// } from "@/controller/erpAfterSale.js";
import * as erpAfterSaleApi from "@/controller/erpAfterSale.js";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "RejectStatement",
  components: { RejectStatementDetail },
  data() {
    return {
      columns: [
        {
          label: "商家ID",
          prop: "supply_id",
        },
        {
          label: "商家名称",
          prop: "supply_name",
        },
        {
          label: "城市",
          prop: "city",
        },
        {
          label: "一级市场",
          prop: "market_name",
        },
        {
          label: "代采组",
          prop: "pg_name",
        },
        {
          label: "次品员",
          prop: "dg_name",
        },
        {
          label: "生成日期",
          prop: "report_date",
        },
        {
          label: "总退换货",
          prop: "total_return",
        },
        {
          label: "转欠货待处理",
          prop: "owe_pending",
        },
        {
          label: "转欠货已换回",
          prop: "owe_processed",
        },
        {
          label: "退款",
          prop: "refund",
        },
        {
          label: "转呆账",
          prop: "stagnant_debts",
        },
        {
          label: "转坏账",
          prop: "bad_debt",
        },
        {
          label: "转抵扣",
          prop: "deduct",
        },
        {
          label: "操作",
          slot: "action",
        },
      ],
      totalDetail: [],
      fetchMethod: erpAfterSaleApi.getRejectDateLogReport,
      buttonList: [
        {
          tag: "button",
          text: "导出列表",
          props: {
            type: "success",
          },
          event: {
            handler: (params) =>
              erpAfterSaleApi.getRejectDateLogReport({
                ...params,
                is_excel: "1",
              }),
            success: (res) => window.open(apiBaseURL + res.file),
          },
        },
        {
          tag: "custom",
          slot: "reportMsg",
        },
      ],
      supplyNameOptions: [],
      searchList: [
        {
          tag: "custom",
          slot: "supply_id",
        },
        {
          tag: "custom",
          slot: "supply_name",
        },
        {
          tag: "custom",
          slot: "city",
        },
        {
          tag: "custom",
          slot: "market",
        },
        {
          tag: "custom",
          slot: "purchase_group",
        },
        {
          tag: "custom",
          slot: "dg_member",
        },
        {
          tag: "date",
          label: "生成日期",
          field: "created_at",
          props: {
            type: "daterange",
            defaultTime: ["00:00:00", "23:59:59"],
          },
          transform: (value = []) => {
            if (value) {
              return {
                created_at: [
                  value[0] ? dayjs(value[0]).unix() : "",
                  value[1] ? dayjs(value[1]).unix() : "",
                ],
              };
            }
            return {
              created_at: [],
            };
          },
        },
      ],
      refresh: false,
      isShowDetailDialog: false,
      detailData: {},
      searchForm: {
        supply_id: "",
        supply_name: "",
        market_id: "",
        dg_member_id: "",
        pgid: "",
        city: "",
      },
      cityOptions: [],
      marketOptions: [],
      purchaseGroupOptions: [],
      defectiveProductSpecialistOptions: [],
    };
  },
  created() {
    this.refresh = true;
    this.fetchSelectOptions();
  },
  methods: {
    handleFormatSearch(params) {
      const result = {
        ...params,
        supply_id: this.searchForm.supply_id,
        start_time: params.created_at[0] || [],
        end_time: params.created_at[1] || [],
        city: this.searchForm.city,
        market_id: this.searchForm.market_id,
        pgid: this.searchForm.pgid,
        dg_member_id: this.searchForm.dg_member_id,
      };
      delete result.created_at;
      return result;
    },
    handleFetchSuccess(res) {
      this.totalDetail = [res.totalDetail];
    },
    // 获取商家名称下拉框
    remoteMethod(value) {
      console.log(value);

      if (value !== "") {
        erpAfterSaleApi
          .getSupplyIdByName({ supply_name: value, page: 1, page_size: 20 })
          .then((data) => {
            const { list } = data;
            this.supplyNameOptions = list;
          });
      } else {
        this.supplyNameOptions = [];
      }
    },
    handleChange() {
      this.searchForm.supply_name = "";
    },
    handleSelectChange(e) {
      this.searchForm.supply_id = e;
    },
    handleReset() {
      this.searchForm = this.$options.data().searchForm;
    },
    // 查看详情
    hanleLookDetail(item) {
      this.isShowDetailDialog = true;
      this.detailData = item;
    },
    fetchSelectOptions() {
      erpAfterSaleApi.listReportOptions().then((res) => {
        this.cityOptions = res.city;
        this.marketOptions = res.market;
        this.purchaseGroupOptions = res.purchase_group;
        this.defectiveProductSpecialistOptions = res.dg_member;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/reject/RejectStatement.vue